export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/moving/index/resources/computed.js